import React from 'react'
import {welcome} from './welcome-data'
import {Link} from 'gatsby'
import './Welcome.scss'

const Welcome = ({romana}: { romana: boolean }) =>
    <div className="welcome">
        <h1>{romana ? welcome['header-ro'] : welcome['header-de']}<span>.</span></h1>
        <p>{romana ? welcome['text-ro'] : welcome['text-de']}</p>
        <Link to={romana ? '/ro/#about' : '#about'}>{romana ? welcome['button-ro'] : welcome['button-de']}</Link>
    </div>


export default Welcome
